import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { colors } from 'utils/colors';

function RiskProfileTable({ result }) {
  // Explicitly check if both risk_profile and risk_statistics exist
  const profileRiskStats =
    result && result.risk_profile && result.risk_profile.risk_statistics;
  const clientRiskStats =
    result && result.risk_statistics && result.risk_statistics.current_values;

  // If any required data is missing, return null
  if (!profileRiskStats || !clientRiskStats || !clientRiskStats.std) {
    return !clientRiskStats || clientRiskStats.current_values === null ? (
      <Note>
        Your selected account(s) contain(s) ONLY unmatched or short-history
        holdings, please review your selection and try again.
      </Note>
    ) : null;
  }

  const isWithinTolerance = !clientRiskStats.std.outof_bounds;

  return (
    <div style={{ marginTop: '20px' }}>
      <Table compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Risk Metric</Table.HeaderCell>
            <Table.HeaderCell>Current</Table.HeaderCell>
            <Table.HeaderCell>
              Target Range{' '}
              <Popup
                trigger={<Icon name="question circle outline" />}
                position="right center"
                content="The target range reflects the historical volatility of your assigned risk profile."
              />
            </Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Std. Deviation of Returns (4 yrs)</Table.Cell>
            <Table.Cell>
              {(clientRiskStats.std.value * 100).toFixed(2)}%
            </Table.Cell>
            <Table.Cell>
              {(profileRiskStats.std.quartile1 * 100).toFixed(2)}% -{' '}
              {(profileRiskStats.std.quartile3 * 100).toFixed(2)}%
            </Table.Cell>
            <Table.Cell>
              <Icon
                style={{
                  marginLeft: '0.5rem 0 0.5rem 6rem',
                  fontSize: '1.5rem',
                }}
                name={isWithinTolerance ? 'check' : 'exclamation triangle'}
                color={isWithinTolerance ? 'blue' : 'red'}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <div>
        <div style={{ color: colors.darkGrey, marginBottom: '1rem' }}>
          <Icon name="info circle" />
          Portfolio risk level is calculated daily. Target allocation risk
          statistics are updated monthly.
        </div>
      </div>
    </div>
  );
}

export default RiskProfileTable;

RiskProfileTable.propTypes = {
  result: PropTypes.object,
};

RiskProfileTable.defaultProps = {
  result: {},
};

const Note = styled.p`
  position: relative;
  max-width: 100% !important;
  font-size: 1.1rem;
  text-align: right;
  width: 100%;
  color: ${colors.red};
`;
